import get from 'lodash/get';

export const dataMapping = (data: any, labelKey: string, valueKey: string) => {
  let options = data.map((option: any) => ({
    ...option,
    label: option[labelKey],
    value: option[valueKey],
  }));
  return options;
};

export const ConsignerMapping = (data: any) => {
  let options = data.data && data.data.length > 0 ? dataMapping(data.data, 'name', 'code') : [];
  return options;
};

export const VehicleMapping = (data: any) => {
  let options = data.data && data.data.length > 0 ? dataMapping(data.data, 'vNo', 'vId') : [];
  return options;
};

export const SauronPlacesMapping = (data: any) => {
  let options = get(data, 'data.data.list')
    ? data.data.list.map((option: any) => ({
        ...option,
        label: option.address,
        value: {
          lat: get(option, 'location.point.coordinates[1]', 0),
          lng: get(option, 'location.point.coordinates[0]', 0),
        },
        source: 'SAURON',
      }))
    : [];
  return options;
};

export const PlacesMapping = (data: any) => {
  let options = data.data
    ? data.data.map((option: any) => ({
        ...option,
        label: option.placeName,
        value: {
          lat: option.placeLat || 0,
          lng: option.placeLng || 0,
        },
        id: option.placeId,
        source: 'SAVED_PLACES',
      }))
    : [];
  return options;
};

export const mapping = [
  {
    key: 'searchConsigner',
    value: ConsignerMapping,
  },
  {
    key: 'searchVehicle',
    value: VehicleMapping,
  },
  {
    key: 'searchSauron',
    value: SauronPlacesMapping,
  },
];
